import React, { useMemo } from "react";
import * as Realm from "realm-web";

const RealmAppContext = React.createContext();

export const useRealmApp = () => {
  const app = React.useContext(RealmAppContext);
  if (!app) {
    throw new Error(
      "You must call useRealmApp() inside of a <RealmAppProvider />"
    );
  }
  return app;
};

export function RealmAppProvider({ appId, children }) {
  const app = useMemo(() => new Realm.App(appId), [appId]);

  // Wrap the Realm.App object's user state with React state
  const [currentUser, setCurrentUser] = React.useState(app.currentUser);

  async function logIn(credentials) {
    await app.logIn(credentials);
    // If successful, app.currentUser is the user that just logged in
    setCurrentUser(app.currentUser);
  }

  async function regiterUser(email, password) {
    await app.emailPasswordAuth.registerUser({ email, password });
  }

  async function logOut() {
    //
    // Log out the currently active user
    await app.currentUser?.logOut();
    // If another user was logged in too, they're now the current user.
    // Otherwise, app.currentUser is null.
    setCurrentUser(app.currentUser);
  }

  async function sendResetPasswordEmail(email) {
    await app.emailPasswordAuth.sendResetPasswordEmail(email);
  }

  const wrapped = useMemo(
    () => ({
      ...app,
      currentUser,
      logIn,
      logOut,
      regiterUser,
      sendResetPasswordEmail,
    }),
    [app, currentUser, logIn, logOut, regiterUser, sendResetPasswordEmail]
  );

  return (
    <RealmAppContext.Provider value={wrapped}>
      {children}
    </RealmAppContext.Provider>
  );
}
